import { vuexfireMutations } from 'vuexfire'

export default {
  ...vuexfireMutations,
  updateProfile(state, profile) {
    state.profile = profile;
  },
  setCustomize(state, customize) {
    state.customize = customize;
  }
}